
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { CommandData } from '@/store/models.def';
import moment from 'moment';
import VueJsonPretty from 'vue-json-pretty';

@Component({
	components: {
		VueJsonPretty,
	},
})
export default class CommandTile extends Vue {
	@Prop() public readonly data!: CommandData;
	public showPayload = false;
	public showLogs = false;
	public get issuedAt() {
		return moment(this.data.issuedAt).format('DD/MM/YYYY HH:mm:ss');
	}
	public get completedAt() {
		if (!this.data.completedAt) { return '-'; }
		return moment(this.data.completedAt).format('DD/MM/YYYY HH:mm:ss');
	}
}
